import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function GoodsAndWarehouseGoodsWrapper({ children }: Props) {
  return (
    <div className="relative grid grid-cols-3 gap-1.5 inset-0 overflow-y-auto overflow-x-clip">
      {children}
    </div>
  );
}
